import { Inject, Injectable, PLATFORM_ID, makeStateKey, TransferState } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

import { CategoryService } from './category.service';
import { Category } from '../models/category';

@Injectable({
    providedIn: 'root'
})
export class CategoryResolverService  {

    constructor(
        private categoryService: CategoryService,
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId
    ) { }

    resolve(): Observable<Category[]> {
        const CATEGORIES_KEY = makeStateKey<Category[]>("categories");
        if (this.transferState.hasKey(CATEGORIES_KEY)) {
            const categories = this.transferState.get(CATEGORIES_KEY, null);
            this.transferState.remove(CATEGORIES_KEY);
            return of(categories);
        } else {
            return this.categoryService.getAll().pipe(
                tap(
                    categories => {
                        if (isPlatformServer(this.platformId)) {
                            this.transferState.set(CATEGORIES_KEY, categories);
                        }
                    }
                )
            );
        }
    }
}
